import styled from "styled-components";

import { fontSizes } from "../../shared/styles/typography";

export const Body = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-bottom: 40px;
`;

export const NewsCard = styled.article`
  background: var(--color-surface, #fff);
  border: 1px solid var(--color-border, #e8eaf0);
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
`;

export const NewsTitle = styled.h2`
  margin: 0;
  font-size: ${fontSizes.base}px;
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-title, #1e293b);
  line-height: 1.35;
`;

export const NewsDescription = styled.p`
  margin: 0;
  font-size: ${fontSizes.base}px;
  line-height: 1.5;
  color: var(--color-text-secondary, #64748b);
  white-space: pre-wrap;
`;

export const MetaRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
`;

export const MetaText = styled.span`
  font-size: ${fontSizes.sm}px;
  color: var(--color-text-tertiary, #6e6a7c);
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 48px 20px;
  color: #6e6a7c;

  svg {
    margin-bottom: 16px;
    opacity: 0.5;
  }

  h2 {
    font-size: ${fontSizes.xl}px;
    font-weight: var(--font-weight-semibold);
    color: var(--color-text-title, #1e293b);
    margin: 0 0 8px;
  }

  p {
    margin: 0;
    font-size: ${fontSizes.sm}px;
    line-height: 1.5;
  }
`;
